import styles from './TeamMemberDetails.module.scss';

import TeamMemberNameInput from 'Screens/Dashboard/Team/Components/TeamCellHandler/TeamInteractions/Interactions/Details/Components/TeamMemberNameInput';
import TeamMemberEmailInput from 'Screens/Dashboard/Team/Components/TeamCellHandler/TeamInteractions/Interactions/Details/Components/TeamMemberEmailInput';
import TeamMemberAddressInput from 'Screens/Dashboard/Team/Components/TeamCellHandler/TeamInteractions/Interactions/Details/Components/TeamMemberAddressInput';
import TeamMemberPhoneInput from 'Screens/Dashboard/Team/Components/TeamCellHandler/TeamInteractions/Interactions/Details/Components/TeamMemberPhoneInput';
import TeamMemberParents from 'Screens/Dashboard/Team/Components/TeamCellHandler/TeamInteractions/Interactions/Details/Components/TeamMemberParents/TeamMemberParents';
import PointsHistoryTable from 'Screens/Dashboard/Team/Components/TeamCellHandler/TeamInteractions/Interactions/Details/Components/PointsHistoryTable/PointsHistoryTable';
import SetTeamMemberTags from 'Screens/Dashboard/Team/Components/TeamCellHandler/TeamInteractions/Interactions/Details/SpecificTeamMemberView/SetTeamMemberTags/SetTeamMemberTags';

const TeamMemberDetails = () => (
    <div className={styles.container}>
        <TeamMemberNameInput />
        <TeamMemberEmailInput />
        <TeamMemberAddressInput />
        <TeamMemberPhoneInput />
        <TeamMemberParents />
        <SetTeamMemberTags />
        <PointsHistoryTable />
    </div>
);

export default TeamMemberDetails;
